import { useEffect, useState } from "react";
import { fetchCoupons } from "@/lib/api";
import { useNavigate } from "react-router-dom";
import StoreLogo from "@/components/StoreLogo";
import { Clock } from "lucide-react";

function daysUntil(iso) {
  if (!iso) return null;
  return Math.ceil((new Date(iso) - new Date()) / (1000 * 60 * 60 * 24));
}

export default function EndingSoon() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCoupons({ sort: "expiring", limit: 30 })
      .then((data) => {
        const soon = data
          .filter((c) => {
            const d = daysUntil(c.expires_at);
            return d !== null && d > 0 && d <= 5;
          })
          .slice(0, 10);
        setItems(soon);
      })
      .catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section
      className="mb-8 border-2 border-[#2d2a32] rounded-2xl p-5 bg-[#fff2ea] hard-shadow-sm"
      data-testid="ending-soon-section"
    >
      <div className="flex items-baseline justify-between mb-4">
        <h2 className="serif text-2xl md:text-3xl tracking-tight flex items-center gap-2">
          <Clock className="w-5 h-5 text-[#ff6b6b]" />
          Ending soon — grab 'em before they go
        </h2>
        <span className="eyebrow text-[10px] text-[#5c5c5c]">UNDER 5 DAYS</span>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-2 -mx-1 px-1">
        {items.map((c) => {
          const d = daysUntil(c.expires_at);
          return (
            <button
              key={c.id}
              onClick={() => navigate(`/coupon/${c.id}`)}
              data-testid={`ending-${c.id}`}
              className="shrink-0 w-56 bg-white border-2 border-[#2d2a32] rounded-xl p-3 text-left hover:hard-shadow-sm hover:-translate-y-0.5 transition-all"
            >
              <div className="flex items-center gap-2 mb-2">
                <StoreLogo store={c.store} storeUrl={c.store_url} size={32} />
                <div className="serif text-base font-semibold truncate flex-1">
                  {c.store}
                </div>
              </div>
              <div className="flex items-center justify-between gap-2">
                <span
                  className="inline-block px-2 py-0.5 text-[10px] font-black eyebrow border border-[#2d2a32] rounded"
                  style={{
                    background: "var(--cat-default)",
                  }}
                >
                  {c.discount_label}
                </span>
                <span className="text-[11px] font-black eyebrow text-white bg-[#ff6b6b] px-2 py-0.5 border border-[#2d2a32] rounded">
                  {d}D LEFT
                </span>
              </div>
              <div className="mt-2 text-xs text-[#3a3a38] line-clamp-2 leading-snug">
                {c.title}
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
}
